import { render, staticRenderFns } from "./ArticoloAlt.vue?vue&type=template&id=c152b78c&"
import script from "./ArticoloAlt.vue?vue&type=script&lang=js&"
export * from "./ArticoloAlt.vue?vue&type=script&lang=js&"
import style0 from "./ArticoloAlt.vue?vue&type=style&index=0&id=c152b78c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports